export const FEATURE_NAME = '@zerops/zerops/features/http-routing-list';
